import { Outlet } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import HistoryIcon from '@mui/icons-material/History';
import LayersIcon from '@mui/icons-material/Layers';
import PeopleIcon from '@mui/icons-material/People';
import { AppShell, type NavItem } from './AppShell';
import { ImpersonationBanner } from './ImpersonationBanner';
import { useImpersonation, withUnit } from '../../hooks/useImpersonation';

export const AdminLayout = () => {
  const { effectiveUnitId } = useImpersonation();
  const navItems: NavItem[] = [
    { label: 'Dashboard', to: withUnit('/admin', effectiveUnitId), icon: <DashboardIcon />, exact: true },
    { label: 'Soutěže', to: withUnit('/admin/competitions', effectiveUnitId), icon: <EmojiEventsIcon /> },
    { label: 'Šablony', to: withUnit('/admin/templates', effectiveUnitId), icon: <LayersIcon /> },
    { label: 'Uživatelé', to: withUnit('/admin/users', effectiveUnitId), icon: <PeopleIcon /> },
    { label: 'Historie změn', to: withUnit('/admin/audit', effectiveUnitId), icon: <HistoryIcon /> },
  ];
  return (
    <AppShell navItems={navItems} title="ADMIN JEDNOTKY">
      <ImpersonationBanner />
      <Outlet />
    </AppShell>
  );
};
